"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({returnLabel, returnFields}) {
        this.state = { country: '' };
        GState.bind(this, ['countries']);
        this.countriesObject = null;
        this.state.countries = Object.values(this.state.countries).map(dataset => {
            const value = returnLabel ? dataset.name : dataset.id;
            if (Array.isArray(returnFields) && returnFields.length) {
                if (!this.countriesObject)
                    this.countriesObject = {};
                const toReturn = {
                    name: dataset.name,
                    id: dataset.id
                };
                returnFields.map(field => toReturn[field] = dataset[field]);
                this.countriesObject[value] = toReturn;
            }
            return {
                label: dataset.name,
                value
            };
        });
    },
    onChange: function (country) {
        this.state.country = country.value;
        this.emit('change', this.countriesObject !== null ? this.countriesObject[country.value] : country.value);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/CountryInput/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Select_template = require("../Select/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Select_tag = marko_loadTag(Select_template);

function render(input, out, __component, component, state) {
  var data = input;

  Select_tag({
      class: input.class,
      placeholder: input.placeholder || Locale("Select your Country"),
      size: input.size || "xl",
      returnAll: true,
      value: input.value || state.country,
      options: state.countries || []
    }, out, __component, "0", [
    [
      "select",
      "onChange",
      false
    ]
  ]);
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
